import Vue from 'vue'

function getConfig () {
    return Vue.prototype.$envConfig
}

function getFeatures () {
  return challengerEnv.features;
}

const challengerEnv = getConfig;
export default challengerEnv;
export const features = getFeatures
